/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting sync process... please wait." |
*
* @param {Sync_Changes_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_starting = /** @type {((inputs?: Sync_Changes_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage du processus de synchronisation... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierungsvorgang wird gestartet... Bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del processo di sincronizzazione... attendere.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начинается процесс синхронизации... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando proceso de sincronización... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在启动同步过程……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期プロセスを開始しています...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक्रोनाइज़ेशन प्रक्रिया शुरू हो रही है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o processo de sincronização... aguarde.")
	return /** @type {LocalizedString} */ ("Starting sync process... please wait.")
});